export const buildApiUrl = (path = '') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const configuredBase = (process.env.REACT_APP_API_URL || 'http://localhost:5000').trim();

  return `${configuredBase.replace(/\/$/, '')}${normalizedPath}`;
};
